export const attrs_input = {
    dense: true,
    outlined: true,
    hideDetails: true,
    persistentPlaceholder: true,
};

export const attrs_switch = {
    inset: true,
    hideDetails: "auto",
    class: "pa-0 ma-0 ml-1 mr-n4",
};

export const attrs_table = {
    "disable-sort": true,
    "disable-pagination": true,
    "hide-default-footer": true,
};
